var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { StyledText } from '../../styles/text';
import { colors, spacing } from '../../styles/theme';
export var StyledNoteText = styled(StyledText)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  padding: ", "px;\n"], ["\n  background-color: ", ";\n  padding: ", "px;\n"])), colors.alabaster, spacing.base);
var templateObject_1;
//# sourceMappingURL=subcomponents.js.map